import React from "react";
import sample from "../assets/sampleimage.png";

const Termscondition = () => {
  return (
    <div>
      {/* Banner Image */}
      <div className="mb-4">
        <img
          src={sample}
          alt="Terms & Conditions Banner"
          className="img-fluid w-100"
        />
      </div>

      {/* Container for Terms Content */}
      <div className="container mb-4">
        <h2 className="text-center mb-4">Terms & Conditions</h2>

        {/* Card with Scrollable Content */}
        <div
          className="card shadow-sm p-4"
          style={{ maxHeight: "70vh", overflowY: "auto" }}
        >
          <p>
            This document is an electronic record in terms of Information Technology Act, 2000 and rules there under as applicable and the amended provisions pertaining to electronic records in various statutes as amended by the Information Technology Act, 2000. This electronic record is generated by a computer system and does not require any physical or digital signatures.
          </p>

          <p>
            This document is published in accordance with the provisions of Rule 3 (1) of the Information Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and regulations, privacy policy and Terms of Use for access or usage of domain name https://www.bskboutique.com/ ('Website'), including the related mobile site and mobile application (hereinafter referred to as 'Platform').
          </p>

          <p>
            The Platform is owned by BSK Boutique, a company incorporated under the Companies Act, 1956 (hereinafter referred to as ‘Platform Owner’, 'we', 'us', 'our'). Your use of the Platform and services and tools are governed by the following terms and conditions (“Terms of Use”) as applicable to the Platform including the applicable policies which are incorporated herein by way of reference...
          </p>

          {/* You can continue to add all other paragraphs similarly */}
          <p>
            ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE PROCEEDING.
          </p>

          <p>
            The use of Platform and/or availing of our Services is subject to the following Terms of Use: To access and use the Services, you agree to provide true, accurate and complete information to us during and after registration...
          </p>

          {/* Continue with all other clauses */}
          <p>
            All disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in India. All concerns or communications relating to these Terms must be communicated to us using the contact information provided on this website.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Termscondition;
